<template>
 <div class="main-box">
   <div id="total" ref="total" class="main-box">
     <iframe v-if="isReset" :src="reportUrl" id="iframe" name="iframe"   frameborder="0" scrolling="auto"></iframe>
   </div>
 </div>

</template>

<script>

import {Base64} from "js-base64";

export default {

  name: 'orderTask',
  props: ['type','resourceId'],
  data() {
    return {
      isReset: true,
      dialogName: '报告预览提交',
      dialogVisible: false,
      method: '',                 // 提交调用方法
      id: '',                     // 提交目标id
      reportUrl: '',
      temp: {}
    }
  },
  created() {
    if(!!this.resourceId){
      this.init(this.type,this.resourceId)
    }
  },
  methods: {
    //打开新增弹窗
    init(type, resourceId){
      let fileServerUrl = 'http://lims.tjthzc.com/lims-web';
      let kkServerUrl = 'http://122.112.152.47:8012/';

      let url = '';
      let currentTime_stamp = new Date().getTime()
      if(type === 'metalReport'){
        url = fileServerUrl + '/resource/metalReport/getResource/' + resourceId + '?fullfilename=' + resourceId + currentTime_stamp + '.docx';
      }else if(type == 'metalOriginal'){
        // url = fileServerUrl + '/web/getResource/' + resourceId + '?fullfilename=' + resourceId + currentTime_stamp + '.pdf';
        url = resourceId

      }

      console.log(url);

      // let url = fileServerUrl +'/web/getFile/' + type + '/' + resourceId ;
      this.reportUrl =  kkServerUrl + 'onlinePreview?url=' + encodeURIComponent(Base64.encode(url))
      console.log(this.reportUrl)
      this.isReset = false;
      this.isReset = true;
    },


  }
}
</script>

<style scoped>


#iframe{
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: 0;
}
#total{
  width: 100%;
}
#total iframe{
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/XrFileView/index.vue